// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1lciC","icon":"SortAdornment_icon__ab3F0","up":"SortAdornment_up__3ndH3","down":"SortAdornment_down__1CqNc","active":"SortAdornment_active__3pW0e"};